import { object, string } from "yup";

export const commentValidationSchema = object().shape({
  comment: string()
    .trim()
    .required("Description should be between 15 and 200 characters.")
    .min(15, "Description should be between 15 and 200 characters.")
    .max(200, "Description should be between 15 and 200 characters."),
});

const commentSchema = string()
  .trim()
  .required("Description should be between 15 and 200 characters.")
  .min(15, "Description should be between 15 and 200 characters.")
  .max(200, "Description should be between 15 and 200 characters.");

export const validateCommentOnly = async (value) => {
  try {
    await commentSchema.validate(value);
    return undefined;
  } catch (err) {
    return err.message;
  }
};



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/save-watchlist-ignoring-properties-modal/commentValidationSchema.js